// Select the entire billing state
export const selectBillingState = (state) => state.billing || {};

// Selectors for individual billing properties
export const selectPlanId = (state) => 
  selectBillingState(state).planId || null;

export const selectSubscriptionId = (state) => 
  selectBillingState(state).subscriptionId || null;

export const selectSubscriptionStatus = (state) => 
  selectBillingState(state).subscriptionStatus || 'na';

export const selectCustomerId = (state) => 
  selectBillingState(state).customerId || null;

export const selectPlanInfo = (state) => 
  selectBillingState(state).planInfo || null;

export const selectProductInfo = (state) => 
  selectBillingState(state).productInfo || null;

export const selectSubscriptionInfo = (state) => 
  selectBillingState(state).subscriptionInfo || null;

export const selectAutoRefresh = (state) =>
  selectBillingState(state).autorefresh !== false; // default true

export const selectRefreshIndex = (state) =>
  selectBillingState(state).refreshIndex || 0; 